import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { IStock } from "types/stock";
import serverCall from "api/serverCall";
import api from "api/api";
import { PaginationState } from "types/common";
import InstrumentTabs from "./components/InstrumentTabs";
import { IFno } from "types/fno";
type Props = {};

function InstrumentsPage({}: Props) {
  const [equities, setEquity] = useState<IStock[]>([]);
  const [fno, setFno] = useState<IFno[]>([]);
  const [equityPage, setEquityPage] = useState<PaginationState>({
    limit: 10,
    page: 0,
  });
  const [equitiesLoading, setEquitiesLoading] = useState<boolean>(false);
  const [totalNumberOfEquities, setTotalNumberOfEquities] = useState<number>(0);
  const [totalNumberOfFno, setTotalNumberOfFno] = useState<number>(0);
  const [tabValue, setTabValue] = useState(0);

  const fetchEquities = async () => {
    setEquitiesLoading(true);
    try {
      const response = await serverCall.get<IStock[]>(api.getEquities());
      setEquity(response);
      setTotalNumberOfEquities(response?.length ?? 0);
    } catch (error) {
      console.error(error);
    } finally {
      setEquitiesLoading(false);
    }
  };

  const fetchFno = async () => {
    setEquitiesLoading(true);
    try {
      const response = await serverCall.get<IFno[]>(api.getFno());
      setFno(response);
      setTotalNumberOfFno(response?.length ?? 0);
    } catch (error) {
      console.error(error);
    } finally {
      setEquitiesLoading(false);
    }
  };

  useEffect(() => {
		fetchEquities();
		fetchFno();
	}, [equityPage]);

	useEffect(() => {
		switch (tabValue) {
			case 0:
				fetchEquities();
				break;
			case 1:
				fetchFno();
				break;
			default:
				break;
		}
	}, [tabValue]);

	return (
		<Grid container spacing={2} justifyContent="center" alignItems="center">
			<InstrumentTabs
				loading={equitiesLoading}
				equities={equities}
				fno={fno}
				page={equityPage}
				setPage={setEquityPage}
				totalNumberOfEquities={totalNumberOfEquities}
				totalNumberOfFno={totalNumberOfFno}
				tabValue={tabValue}
				setTabValue={setTabValue}
				fetchFno={fetchFno}
				fetchEquities={fetchEquities}
			/>
		</Grid>
	);
}

export default InstrumentsPage;
